import React, { useState } from 'react';
import DataTable from './DataTable';

/**
 * Card-internal chart wrapper: title row, legend, and a Chart | Table toggle
 * so every value is reachable without hovering (the table view twin).
 */
export default function ChartFrame({ title, subtitle, legend = [], table, children, footnote, actions }) {
  const [view, setView] = useState('chart');
  const showToggle = Boolean(table && table.columns && table.rows);
  return (
    <div className="le-chart-frame">
      <div className="le-chart-frame-head">
        <div className="le-chart-frame-titles">
          {title ? <div className="le-chart-title">{title}</div> : null}
          {subtitle ? <div className="le-chart-subtitle">{subtitle}</div> : null}
        </div>
        <div className="le-chart-frame-tools">
          {actions}
          {showToggle ? (
            <div className="le-segmented le-segmented-sm" role="tablist" aria-label="Chart or table view">
              <button type="button" role="tab" aria-selected={view === 'chart'} className={view === 'chart' ? 'active' : ''} onClick={() => setView('chart')}>Chart</button>
              <button type="button" role="tab" aria-selected={view === 'table'} className={view === 'table' ? 'active' : ''} onClick={() => setView('table')}>Table</button>
            </div>
          ) : null}
        </div>
      </div>
      {legend.length > 1 && view === 'chart' ? (
        <div className="le-legend" aria-label="Legend">
          {legend.map((item) => (
            <span key={item.id} className="le-legend-item">
              <span className={`le-legend-swatch le-legend-swatch-${item.kind || 'rect'}`} style={{ '--swatch': item.color }} />
              {item.label}
            </span>
          ))}
        </div>
      ) : null}
      {view === 'chart' ? children : <DataTable columns={table.columns} rows={table.rows} />}
      {footnote ? <div className="le-chart-footnote">{footnote}</div> : null}
    </div>
  );
}
